import { render, staticRenderFns } from "./ScoreBasdai.vue?vue&type=template&id=4228811a&scoped=true"
import script from "./ScoreBasdai.vue?vue&type=script&lang=js"
export * from "./ScoreBasdai.vue?vue&type=script&lang=js"
import style0 from "./ScoreBasdai.vue?vue&type=style&index=0&id=4228811a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4228811a",
  null
  
)

export default component.exports